export enum MessageType {
  error = 'error',
  success = 'success',
  warning = 'warning',
  neutral = 'neutral',
}
